import { Box, Button, HStack, Text, Spinner, Icon } from "@chakra-ui/react";
import { RepeatIcon } from "@chakra-ui/icons";
import { FaClock } from "react-icons/fa";
import { useRefreshCountdown } from "../hooks/useRefreshCountdown";

export interface RefreshToolbarProps {
  onManualRefresh: () => void;
  isRefreshing: boolean;
  showCountdown: boolean;
  dataUpdatedAt: number | undefined;
  refreshIntervalMinutes: number;
}

export const RefreshToolbar: React.FC<RefreshToolbarProps> = ({
  onManualRefresh,
  isRefreshing,
  showCountdown,
  dataUpdatedAt,
  refreshIntervalMinutes,
}) => {
  const minutesRemaining = useRefreshCountdown(
    dataUpdatedAt,
    refreshIntervalMinutes,
    showCountdown
  );
  return (
    <Box
      bg="white"
      borderBottom="1px"
      borderColor="gray.200"
      px={8}
      py={3}
      shadow="sm"
    >
      <HStack spacing={6} align="center">
        {/* Manual Refresh Button */}
        <Button
          leftIcon={isRefreshing ? <Spinner size="sm" /> : <RepeatIcon />}
          onClick={onManualRefresh}
          isLoading={isRefreshing}
          loadingText="Refreshing"
          colorScheme="blue"
          variant="outline"
          size="sm"
          isDisabled={isRefreshing}
        >
          Manual Refresh
        </Button>

        {/* Countdown Display */}
        {showCountdown && !isRefreshing && (
          <HStack spacing={2} color="gray.600">
            <Icon as={FaClock} boxSize={4} />
            <Text fontSize="sm" fontWeight="500">
              Next refresh in {minutesRemaining}{" "}
              {minutesRemaining === 1 ? "minute" : "minutes"}
            </Text>
          </HStack>
        )}

        {/* Refreshing State Message */}
        {isRefreshing && (
          <Text fontSize="sm" color="gray.600" fontWeight="500">
            Fetching latest data...
          </Text>
        )}
      </HStack>
    </Box>
  );
};
